import {
  Fragment,
  useRef,
  useState,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import {
  Form,
  Col,
  Row,
  Input,
  Select,
  Typography,
  Button,
  Spin,
  Modal,
  message,
  Tabs,
  Collapse,
  Tag,
  Tooltip,
  Popover,
  Dropdown,
  Divider,
  Drawer,
  Segmented,
} from "antd";
import CustomButton from "../../../globals/components/button";
import Icon from "@ant-design/icons";
import UploadComponent from "../../../globals/components/uploadComponent";
import {
  EditOutlined,
  ExclamationCircleFilled,
  SearchOutlined,
  LeftOutlined,
  SettingFilled,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  CaretRightOutlined,
  QuestionCircleOutlined,
  UserOutlined,
  MoreOutlined,
  BranchesOutlined,
  FileUnknownOutlined,
  DownloadOutlined,
  CloseOutlined,
  PlusOutlined,
  PlusCircleOutlined,
  FilterOutlined,
  SortDescendingOutlined,
  SortAscendingOutlined,
  CalendarOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import ContentPreviewModal from "./PreviewContent/previewModal";
import { useDispatch } from "react-redux";
import { getContentByTemplate } from "../../Workflow/Workflow.action";
import {
  setAddFieldsModalVisible,
  setModalVisible,
  setresetcustomAddedFields,
  setTemplateIds,
  showContentPreviewmodal,
} from "../content.slice";
import {
  createcontenttype,
  getClausesList,
  getContenttype,
  getSampleContent,
} from "../../ContentServices/contentservices.Action";
import {
  createContent,
  updateContent,
  contentUploadDoc,
  SubmitContentforcreation,
  contentUploadhtmltoDoc,
} from "../content.Action";
import { useHistory } from "react-router-dom";
import "./Modal.less";
import "./Createcontent.less";
import { editTaskContentTemplate } from "../../Taskmanagement/Taskmanagement.Action";
import { createTemplateModal } from "../../Template/Template.slice";
import CKEditor from "ckeditor4-react";
import { updateContentData } from "../../Taskmanagement/Taskmanagement.Slice";
import ImageProvider from "../Imageprovider";
import { setClauseModalVisible } from "../../ContentServices/contentservices.Slice";
import AiIcon from "../../../assets/images/AiIcon";
import { setContentDetails } from "../../AskAI/AskAI.slice";
import "./ckeditor-custom.css";
import { setCreditExhaustModalVisible } from "../../users/user.slice";

const { Text } = Typography;
const { Option } = Select;
const { Panel } = Collapse;
const { confirm } = Modal;

// Constants
const FORM_LAYOUTS = {
  main: {
    labelCol: { xs: 24, sm: 24, md: 24, lg: 3 },
    wrapperCol: { xs: 24, sm: 24, md: 24, lg: 20 },
  },
  full: {
    labelCol: { xs: 24, sm: 24, md: 24, lg: 24 },
    wrapperCol: { xs: 24, sm: 24, md: 24, lg: 24 },
  },
  newType: {
    labelCol: { xs: 0, sm: 0, md: 0, lg: 0 },
    wrapperCol: { xs: 24, sm: 24, md: 24, lg: 24 },
  },
};

const TOKEN_LABEL_MAP = {
  counterpartyName: "Counterparty",
  vendorName: "Vendor",
};

const CreateContent = (props) => {
  const {
    intl: { formatMessage },
    content,
    contentservice,
    template,
    taskmanagement,
    user: { access_modules },
    local: { _locale },
    company: { creditDetails },
    company,
  } = props;
console.log(company)
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const history = useHistory();
  const editorRef = useRef(null);
  const inputRef = useRef(null);

  // State
  const [contents, setContent] = useState(content.editRecord?.content || "");
  const [Template, setTemplate] = useState(
    content.editRecord?.templete_ids?.[0] || []
  );
  const [ContentDrawertype, setContentDrawertype] = useState(
    content.type === "edit" ? "fill" : "Create"
  );
  const [Drawertitle, setDrawertitle] = useState(
    content.editRecord?.contentName || ""
  );
  const [Key, setKey] = useState("1");
  const [collapseRoleFieldsKey, setCollapseRoleFieldsKey] = useState([
    "1",
    "2",
  ]);
  const [collapsecontractFieldsKey, setCollapseContractFieldsKey] = useState([
    "1",
  ]);
  const [isSidebarvisible, setSidebarVisible] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [name, setName] = useState("");
  const [isckeditorvisible, setIsCkeditorVisible] = useState(
    Object.keys(content.editRecord).length === 0
  );
  const [users, setUsers] = useState([]);
  const [editorMode, setEditorMode] = useState("edit"); // "edit" | "tag"

  const SelectedTemplateValueid = Form.useWatch("templete_ids", form);

  // Destructure props with defaults
  const {
    contenttypeTableData = [],
    isLoading = false,
    samplecontentTableData = [],
    clauseTableData = [],
    isClauseListLoading = false,
  } = contentservice;

  const {
    editRecord = {},
    isVisible = false,
    isCreateLoading = false,
    contentPagination = {},
    type = "",
    taskDetailsdata = {},
    template_id = "",
    backendvariablesforcontent = {},
    editRecordContent = "",
    contentPreviewLoading = false,
    contentPreviewData = "",
    customAddedFields = [],
  } = content;

  const { templateTableData = [] } = template;
  const taskPagination = taskmanagement?.taskPagination;

  // Memoized values
  const clausesfilteredData = useMemo(
    () =>
      clauseTableData.filter((item) =>
        item?.clauseTitle?.toLowerCase().includes(searchText.toLowerCase())
      ),
    [clauseTableData, searchText]
  );

  const Templatedata = useMemo(
    () =>
      templateTableData.filter((item) => Template?.includes(item._id)) || [],
    [templateTableData, Template]
  );
  const FIELD_LABEL_MAP = useMemo(() => {
    const mapping = {};

    // Default template vars
    backendvariablesforcontent?.defaultTemplate?.forEach((f) => {
      const translated =
        f.translation?.[_locale]?.label || f.label || f.field_label;
      mapping[f.field_label] = translated;
    });

    // Company vars
    backendvariablesforcontent?.companyVars?.forEach((f) => {
      const translated = f.translation?.[_locale]?.title || f.title || f.key;
      mapping[f.key] = translated; // use key for token
    });

    // Counterparty vars
    backendvariablesforcontent?.counterpartyVars?.forEach((f) => {
      const translated = f.translation?.[_locale]?.title || f.title || f.key;
      mapping[f.key] = translated;
    });

    return mapping;
  }, [backendvariablesforcontent, _locale]);

  // Get template fields for validation
  const getTemplateFields = useCallback(() => {
    let rTemplateFeilds = [];

    if (editRecord && ["taskEditContent", "edittaskcontent"].includes(type)) {
      taskDetailsdata?.dynamicParameters?.forEach((rte) => {
        rTemplateFeilds.push(rte.field_label);
      });
    } else {
      Templatedata.forEach((er) => {
        er.fields.forEach((rte) => {
          rTemplateFeilds.push(rte.field_label);
        });
      });
    }

    backendvariablesforcontent?.counterpartyVars?.forEach((rte) => {
      rTemplateFeilds.push(rte?.fieldname);
    });

    backendvariablesforcontent?.companyVars?.forEach((rte) => {
      rTemplateFeilds.push(rte?.fieldname);
    });

    return rTemplateFeilds;
  }, [
    editRecord,
    type,
    taskDetailsdata,
    Templatedata,
    backendvariablesforcontent,
  ]);
  // Callback functions
  const dataFeed = useCallback(
    (opts, callback) => {
      const matchProperty = "fieldsname";
      let data = users.filter(
        (item) =>
          item[matchProperty]
            .toLowerCase()
            .indexOf(opts.query.toLowerCase()) === 0
      );

      data = data.sort((a, b) =>
        a[matchProperty].localeCompare(b[matchProperty], undefined, {
          sensitivity: "accent",
        })
      );
      callback(data);
    },
    [users]
  );
  const backenddatafeed = useCallback(
    (opts, callback) => {
      const matchProperty = "title";
      let data = [
        ...(backendvariablesforcontent?.companyVars || []),
        ...(backendvariablesforcontent?.counterpartyVars || []),
      ]
        .map((item, index) => ({
          ...item,
          title: item.translation?.[_locale]?.title || item?.title,
          key: `{${item?.key}}`,
        }))
        .filter(
          (item) =>
            item[matchProperty]
              .toLowerCase()
              .indexOf(opts.query.toLowerCase()) === 0
        );

      data = data.sort((a, b) =>
        a[matchProperty].localeCompare(b[matchProperty], undefined, {
          sensitivity: "accent",
        })
      );

      callback(data);
    },
    [backendvariablesforcontent, _locale]
  );
  // CKEditor configuration
  const editorConfig = useMemo(
    () => ({
      fontSize_sizes:
        "8pt;9pt;10pt;11pt;12pt;14pt;16pt;18pt;20pt;22pt;24pt;26pt;28pt;36pt;48pt;72pt;",
      extraPlugins:
        "mentions,emoji,colorbutton,colordialog,find,font,print,pagebreak,language",
      customConfig: "",
      contentsCss: [
        "http://cdn.ckeditor.com/4.22.1/full-all/contents.css",
        "https://ckeditor.com/docs/ckeditor4/4.22.1/examples/assets/mentions/contents.css",
        "/ckeditor-custom.css",
      ],
      defaultLanguage: "fr",
      contentsLanguage: "fr",
      toolbarCanCollapse: true,
      font_names:
        "Baguet Script;Agency FB;Arial;Times New Roman;Verdana;Trebuchet MS;Courier New;Georgia;Comic Sans MS;",
      mentions: [
        {
          feed: dataFeed,
          marker: "$",
          itemTemplate:
            '<li data-id="{id}"><strong class="username">{fieldsname}</strong><span class="fullname">{fieldforcontent}</span></li>',
          outputTemplate: `<strong contenteditable="false">{fieldforcontent}</strong>&nbsp;`,
          minChars: 0,
        },
        {
          feed: backenddatafeed,
          marker: "#",
          itemTemplate: '<li data-id="{id}"><strong>{title}</strong></li>',
          outputTemplate: `<b contenteditable="false">{key}</b><span>&nbsp;</span>`,
          minChars: 0,
        },
      ],
      height: "62dvh",
      removeButtons: "PasteFromWord",
      allowedContent: true,
      bodyClass: "document-editor",
      removePlugins: "wsc",
      extraAllowedContent: "span[data-key]{*}(*);",
    }),
    []
  );

  // Effects
  useEffect(() => {
    dispatch(getContenttype({ sortBy: "DESC" }));
    dispatch(getSampleContent({ sortBy: "DESC" }));
    dispatch(getClausesList({ sortBy: "ASC" }));
  }, [dispatch]);

  useEffect(() => {
    setDrawertitle(
      form.getFieldValue("contentName") || editRecord?.contentName
    );
  }, [ContentDrawertype, form, editRecord]);

  useEffect(() => {
    if (isVisible) {
      form.setFieldsValue({ content: contentPreviewData });
      setContent(contentPreviewData || "");
    }
  }, [contentPreviewData, form, isVisible]);

  useEffect(() => {
    if (type === "edit") {
      form.setFieldsValue({ content: editRecord.content });
      setContent(editRecord.content);
    }
  }, [editRecord, type, form]);

  // Update CKEditor visibility and users when backend variables change
  useEffect(() => {
    const defaultvariables =
      backendvariablesforcontent?.defaultTemplate?.length > 0 &&
      backendvariablesforcontent.defaultTemplate.map((rt, rtIndex) => ({
        id: rtIndex,
        fieldsname: rt.label,
        fieldforcontent: `{${rt.field_label}}`,
      }));

    setIsCkeditorVisible(false);
    setUsers(defaultvariables || []);

    const timer = setTimeout(() => {
      setIsCkeditorVisible(true);
    }, 500);

    return () => clearTimeout(timer);
  }, [backendvariablesforcontent, ContentDrawertype]);
  const makeTagSpan = useCallback(
    (key) => {
      const label = FIELD_LABEL_MAP[key] || key;

      return `<span class="intuitive-tag" data-key="${key}" contenteditable="false"
    style="display:inline-block; background:#4CAF50; color:#fff; padding:4px 10px; border-radius:12px; font-weight:600; line-height:1; cursor:pointer; white-space:nowrap;">
      ${label}
  </span>`;
    },
    [FIELD_LABEL_MAP]
  );

  // Handle template selection
  useEffect(() => {
    if (SelectedTemplateValueid) {
      const Templatedataformention =
        templateTableData
          .filter((item) => SelectedTemplateValueid?.includes(item._id))
          ?.map((eve) => ({
            ...eve,
            fields:
              [
                ...backendvariablesforcontent?.defaultTemplate,
                ...eve?.fields,
              ] || [],
          })) || [];

      const contentmentionsdata = Templatedataformention.flatMap((ert) =>
        ert.fields.map((rt, rtIndex) => ({
          id: rtIndex,
          fieldsname: rt.label,
          fieldforcontent: `{${rt.field_label}}`,
        }))
      );

      setUsers(contentmentionsdata);
      setIsCkeditorVisible(false);

      if (Template) {
        const timer = setTimeout(() => {
          setIsCkeditorVisible(true);
        }, 100);
        return () => clearTimeout(timer);
      }
    }
  }, [
    templateTableData,
    SelectedTemplateValueid,
    backendvariablesforcontent,
    Template,
  ]);

  const toggleMode = useCallback(
    (mode) => {
      if (!editorRef.current) return;
      const editor = editorRef.current;
      let html = editor.getData();

      if (mode === "tag") {
        // Convert all raw tokens into pills
        html = html.replace(
          /\{([a-zA-Z0-9_]+)\}/g,
          (match, tokenKey) => makeTagSpan(tokenKey) // uses FIELD_LABEL_MAP with translations
        );
      } else {
        // Convert pills back into raw tokens
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        tmp.querySelectorAll(".intuitive-tag").forEach((el) => {
          const key = el.getAttribute("data-key");
          el.replaceWith(`{${key}}`);
        });
        html = tmp.innerHTML;
      }

      editor.setData(html);
      setEditorMode(mode);
    },
    [makeTagSpan]
  );

  const validateInput = useCallback(
    (rule, value, callback) => {
      if (!/^[A-Za-z0-9\s]+$/.test(value)) {
        // callback(formatMessage({ id: "input_text_validation_message" }));
        callback();
      } else {
        callback();
      }
    },
    [formatMessage]
  );

  const checkFileType = useCallback((file) => {
    const fileNameParts = file.name.split(".");
    const fileType = fileNameParts[fileNameParts.length - 1];

    if (!["doc", "docx"].includes(fileType.toLowerCase())) {
      message.error(`Only doc,docx files are allowed!`);
      return false;
    }
    return true;
  }, []);

  const findContractType = useCallback(() => {
    const typeId =
      form.getFieldValue("contentType") || editRecord?.contentType?.[0]?._id;
    const contractType = contenttypeTableData.find(
      (contractType) => contractType._id === typeId
    );
    return contractType?.contentType || "Unknown";
  }, [form, editRecord, contenttypeTableData]);

  const findsvgForTemplate = useCallback((val, type) => {
    return ImageProvider.find((rt) => {
      if (type) {
        return rt?.dataType === val && type === rt?.typeOfOptions;
      } else {
        return rt?.dataType === val;
      }
    });
  }, []);

  const onNameChange = useCallback((event) => {
    setName(event.target.value);
  }, []);

  const addItem = useCallback(
    async (e) => {
      e.preventDefault();
      await form.validateFields(["newcontentType"]);

      const data = { contentType: name };

      dispatch(
        createcontenttype({ data, contenttypePagination: { sortBy: "DESC" } })
      ).then((response) => {
        form.setFieldsValue({ contentType: response?.payload?.data?._id });
        form.resetFields(["newcontentType"]);
        setName("");
      });

      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    },
    [form, name, dispatch]
  );

  const modelClose = useCallback(
    async (form) => {
      form.resetFields();
      dispatch(setModalVisible({ visible: false, record: {} }));
      dispatch(setresetcustomAddedFields());
      setContent("");
    },
    [dispatch]
  );

  const SetTemplate = useCallback((value) => {
    setTemplate(value);
    setTemplateIds(value);
  }, []);

  const showtaskConfirm2 = useCallback(
    (record) => {
      confirm({
        title: formatMessage({ id: "content_validation" }),
        icon: <ExclamationCircleFilled />,
        content: "",
        okText: formatMessage({ id: "Ok" }),
        okType: "default",
        cancelText: false,
        okCancel: true,
        onOk() {
          ConstentSubmitCall(record);
        },
      });
    },
    [formatMessage]
  );

  const ConstentSubmitCall = useCallback(
    async (data) => {
      const Taskdata = {
        taskId: taskDetailsdata?._id,
        content: data,
      };

      if (type === "edit") {
        dispatch(updateContent({ data, contentPagination }));
      } else if (["edittaskcontent"].includes(type)) {
        dispatch(
          editTaskContentTemplate({
            Taskdata,
            taskPagination,
            fortaskcontent: true,
          })
        );
      } else if (type === "taskEditContent") {
        dispatch(
          updateContentData({
            content: { ...data, _id: data.id },
          })
        );
        dispatch(setModalVisible({ isVisible: false }));
      } else {
        await dispatch(createContent({ data, contentPagination }));
        if (type === "createEdit") {
          dispatch(
            getContentByTemplate({
              templateId: editRecord?.templete_ids?.[0],
            })
          );
        }
      }
    },
    [
      dispatch,
      type,
      taskDetailsdata,
      contentPagination,
      taskPagination,
      editRecord,
    ]
  );

  const onOk = useCallback(
    async (form) => {
      const values = await form.validateFields();
      const rTemplateFeilds = getTemplateFields();
      let rawContent = contents;

      if (editorRef.current) {
        const tmp = document.createElement("div");
        tmp.innerHTML = editorRef.current.getData();
        tmp.querySelectorAll(".intuitive-tag").forEach((el) => {
          const key = el.getAttribute("data-key");
          el.replaceWith(`{${key}}`);
        });
        rawContent = tmp.innerHTML;
      }
      const data = {
        id: editRecord?._id,
        contentName: Drawertitle || values?.contentName,
        contentType:
          editRecord?.contentType?.length > 0
            ? editRecord?.contentType[0]?._id
            : "",
        sample_content: values?.sample_content,
        content: rawContent,
        customFields:
          customAddedFields?.length > 0
            ? customAddedFields.map(({ _id, ...rest }) => rest)
            : [],
        templete_ids:
          form.getFieldValue("templete_ids") &&
          Array.isArray(form.getFieldValue("templete_ids"))
            ? form.getFieldValue("templete_ids")
            : [form.getFieldValue("templete_ids")],
        ...(editRecord?.contentStatus === 45 && { stepId: 2 }),
      };

      let warningArr = [];
      if (contents) {
        const found = [];
        const rxp = /{([^}]+)}/g;
        let curMatch;

        while ((curMatch = rxp.exec(contents))) {
          if (rTemplateFeilds.includes(curMatch[1])) {
            found.push(curMatch[1]);
          } else {
            warningArr.push(curMatch[1]);
          }
        }

        const calculationLength =
          rTemplateFeilds.length < backendvariablesforcontent?.length
            ? backendvariablesforcontent.length - rTemplateFeilds.length
            : rTemplateFeilds.length - backendvariablesforcontent.length;

        if (found?.length === 0 || calculationLength !== found?.length) {
          showtaskConfirm2(data);
        } else {
          ConstentSubmitCall(data);
        }
      }
    },
    [
      form,
      editRecord,
      Drawertitle,
      contents,
      customAddedFields,
      getTemplateFields,
      backendvariablesforcontent,
      showtaskConfirm2,
      ConstentSubmitCall,
    ]
  );

  const handlesampledatachange = useCallback(
    (e) => {
      if (e) {
        const data = samplecontentTableData.find((item) => item?._id === e);
        form.setFieldsValue({ content: data?.content });
        setContent(data.content || "");
      } else {
        form.setFieldsValue({ content: "" });
        setContent("");
      }
    },
    [samplecontentTableData, form]
  );

  const handlePreview = useCallback(() => {
    const Templatedata =
      templateTableData.find((item) => Template?.includes(item._id)) || {};
    const updatedObject = {
      ...Templatedata,
      fields: backendvariablesforcontent?.defaultTemplate.concat(
        customAddedFields,
        Templatedata.fields || []
      ),
    };

    const customAndDefaultArray = [
      ...customAddedFields,
      ...backendvariablesforcontent?.defaultTemplate,
    ];

    const rTemplateFeilds = [];
    customAndDefaultArray.forEach((rte) => {
      rTemplateFeilds.push(rte.field_label);
    });

    if (contents && rTemplateFeilds.length) {
      const found = [];
      rTemplateFeilds.forEach((eve) => {
        if (contents.includes(eve)) {
          found.push(eve);
        }
      });
      let rawContent = contents;

      if (editorRef.current) {
        const tmp = document.createElement("div");
        tmp.innerHTML = editorRef.current.getData();
        tmp.querySelectorAll(".intuitive-tag").forEach((el) => {
          const key = el.getAttribute("data-key");
          el.replaceWith(`{${key}}`);
        });
        rawContent = tmp.innerHTML;
      }
      dispatch(
        showContentPreviewmodal({
          visible: true,
          record: {
            ...updatedObject,
            fields: updatedObject?.fields,
            contents: rawContent,
            contentFeild: found,
          },
          type: "createfromcontent",
        })
      );
    }
  }, [
    templateTableData,
    Template,
    backendvariablesforcontent,
    customAddedFields,
    contents,
    dispatch,
  ]);

  // Menu items
  const items = useMemo(
    () => [
      {
        key: "1",
        danger: true,
        icon: <CloseOutlined />,
        onClick: () => modelClose(form),
        label: <span>{formatMessage({ id: "cancel" })}</span>,
      },
      {
        key: "2",
        icon: <CaretRightOutlined />,
        onClick: handlePreview,
        label: <span>{formatMessage({ id: "preview" })}</span>,
      },
      {
        key: "3",
        type: "primary",
        danger: false,
        icon: <EditOutlined />,
        loading: isCreateLoading,
        onClick: () => onOk(form),
        label:
          editRecord?.contentStatus === 46
            ? formatMessage({ id: "update" })
            : formatMessage({ id: "create" }),
      },
    ],
    [
      modelClose,
      form,
      formatMessage,
      handlePreview,
      isCreateLoading,
      onOk,
      editRecord,
    ]
  );

  const extraItems = useMemo(
    () => [
      {
        key: "1",
        type: "group",
        label: formatMessage({ id: "add" }),
        children: [
          {
            key: "1-1",
            label: formatMessage({ id: "add_field" }),
            icon: <PlusCircleOutlined />,
            onClick: () => {
              dispatch(setAddFieldsModalVisible({ visible: true }));
            },
          },
        ],
      },
    ],
    [formatMessage, dispatch]
  );

  const sortingItems = useMemo(
    () => [
      {
        key: "sort_by_a_z",
        label: formatMessage({
          id: "sort_by_a_z",
          defaultMessage: "Sort by A-Z",
        }),
        icon: <SortAscendingOutlined />,
        onClick: () =>
          dispatch(getClausesList({ sortBy: "ASC", orderBy: "clauseTitle" })),
      },
      {
        key: "sort_by_z_a",
        label: formatMessage({
          id: "sort_by_z_a",
          defaultMessage: "Sort by Z-A",
        }),
        icon: <SortDescendingOutlined />,
        onClick: () =>
          dispatch(getClausesList({ sortBy: "DESC", orderBy: "clauseTitle" })),
      },
      {
        key: "sort_by_created_at",
        label: formatMessage({
          id: "sort_by_created_at",
          defaultMessage: "Sort by CreatedAt",
        }),
        icon: <CalendarOutlined />,
        onClick: () =>
          dispatch(getClausesList({ sortBy: "ASC", orderBy: "CreatedAt" })),
      },
      {
        key: "sort_by_updated_at",
        label: formatMessage({
          id: "sort_by_updated_at",
          defaultMessage: "Sort by UpdatedAt",
        }),
        icon: <CalendarOutlined />,
        onClick: () =>
          dispatch(getClausesList({ sortBy: "ASC", orderBy: "updatedAt" })),
      },
      {
        key: "default",
        label: formatMessage({ id: "default", defaultMessage: "Default" }),
        icon: <ReloadOutlined />,
        onClick: () => dispatch(getClausesList({ sortBy: "ASC" })),
      },
    ],
    [formatMessage, dispatch]
  );

  const renderDrawerTitle = () => {
    if (ContentDrawertype !== "fill") return null;

    return (
      <div className="content_drawer_title">
        <Input
          onBlur={() => {
            if (Drawertitle) {
              setDrawertitle(Drawertitle);
            } else {
              setDrawertitle(editRecord?.contentName);
            }
          }}
          className="title_drawer_dynamic"
          style={{
            maxWidth: "150px",
            width: "auto",
            fontSize: "18px",
            fontWeight: "500",
          }}
          bordered={false}
          onChange={(e) => setDrawertitle(e.target.value)}
          value={Drawertitle}
        />
        &nbsp;
        <div>
          <Tag color="green">{findContractType()}</Tag>
        </div>
        &nbsp;
        <SettingFilled />
      </div>
    );
  };

  const renderDrawerExtra = () => {
    if (ContentDrawertype !== "fill") return null;

    if (window.innerWidth > 752) {
      return (
        <Fragment>
          <CustomButton onClick={() => modelClose(form)}>
            {formatMessage({ id: "cancel" })}
          </CustomButton>
          <CustomButton
            icon={<CaretRightOutlined />}
            style={{ margin: "0 0 0 20px" }}
            disabled={
              taskDetailsdata?.taskStatus === 4 ||
              taskDetailsdata?.taskStatus === 5 ||
              !contents
            }
            type="primary"
            onClick={handlePreview}
          >
            {formatMessage({ id: "preview" })}
          </CustomButton>
          <CustomButton
            style={{ margin: "0 0 0 20px" }}
            disabled={
              taskDetailsdata?.taskStatus === 4 ||
              taskDetailsdata?.taskStatus === 5 ||
              !contents
            }
            type="primary"
            onClick={() => onOk(form)}
            loading={isCreateLoading}
          >
            {editRecord?.contentStatus === 46
              ? formatMessage({ id: "update" })
              : formatMessage({ id: "create" })}
          </CustomButton>
        </Fragment>
      );
    }

    return (
      <Dropdown trigger={["click"]} menu={{ items }} showArrow={false}>
        <CustomButton icon={<MoreOutlined />} />
      </Dropdown>
    );
  };

  const renderCreateContentForm = () => {
    if (ContentDrawertype === "fill") return null;

    return (
      <div className="content-fill-main">
        <div className="Create_content_step1_main">
          <div className="Create_content_title">
            {formatMessage({ id: "create_content" })}
          </div>
          <div className="Create_content_fillform">
            <Form.Item
              labelAlign="left"
              {...FORM_LAYOUTS.main}
              name="contentName"
              label={formatMessage({ id: "name" })}
              rules={[
                {
                  required: true,
                  message: formatMessage({ id: "content_name_rule" }),
                },
                { whitespace: true },
                { validator: validateInput },
              ]}
            >
              <Input
                size="large"
                disabled={["taskEditContent", "edittaskcontent"].includes(type)}
                placeholder={formatMessage({ id: "plce_content_name" })}
              />
            </Form.Item>

            <Form.Item
              labelAlign="left"
              {...FORM_LAYOUTS.main}
              name="contentType"
              label={formatMessage({ id: "type" })}
              rules={[
                {
                  required: true,
                  message: formatMessage({ id: "please_content_type_rule" }),
                },
              ]}
            >
              <Select
                size="large"
                optionLabelProp="label"
                getPopupContainer={(trigger) => trigger.parentNode}
                optionFilterProp="children"
                showSearch
                showArrow
                disabled={["taskEditContent", "edittaskcontent"].includes(type)}
                loading={isLoading}
                placeholder={formatMessage({ id: "plce_select_content_type" })}
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    {[200].includes(access_modules) && (
                      <>
                        <Divider style={{ margin: "8px 0" }} />
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: formatMessage({
                                id: "contentType_rule",
                              }),
                            },
                            {
                              whitespace: true,
                              message: "Enter valid contract type",
                            },
                            { validator: validateInput },
                          ]}
                          name="newcontentType"
                          style={{ margin: "0 0 8px" }}
                          labelCol={0}
                          wrapperCol={24}
                        >
                          <Row style={{ padding: "0 8px 4px", width: "100%" }}>
                            <Col lg={18} md={16} xs={12} sm={14}>
                              <Form.Item
                                style={{ margin: "0 0 8px" }}
                                name="newcontentType"
                              >
                                <Input
                                  style={{ width: "100%" }}
                                  placeholder={formatMessage({
                                    id: "plce_contentType",
                                  })}
                                  ref={inputRef}
                                  value={name}
                                  onChange={onNameChange}
                                />
                              </Form.Item>
                            </Col>
                            <Col lg={4} md={6} xs={8} sm={8} offset={1}>
                              <Form.Item style={{ margin: "0 0 8px" }}>
                                <Button
                                  block
                                  loading={contentservice?.isCreateLoading}
                                  type="primary"
                                  icon={<PlusOutlined />}
                                  onClick={addItem}
                                >
                                  {formatMessage({ id: "add" })}
                                </Button>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Form.Item>
                      </>
                    )}
                  </>
                )}
              >
                {contenttypeTableData.map((rt, index) => (
                  <Option label={rt?.contentType} key={index} value={rt._id}>
                    <span>{rt?.contentType}</span>
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>

          <div className="Create_content_submit">
            <Button
              loading={isCreateLoading}
              onClick={async () => {
                const values = await form.validateFields([
                  "contentType",
                  "contentName",
                ]);
                const data = {
                  id: editRecord?._id,
                  contentName: values?.contentName,
                  contentType: values?.contentType,
                  templete_ids:
                    values.templete_ids && Array.isArray(values.templete_ids)
                      ? values.templete_ids
                      : [values.templete_ids],
                  stepId: 1,
                };

                dispatch(
                  SubmitContentforcreation({ data, contentPagination })
                ).then(() => {
                  setContentDrawertype("fill");
                });
              }}
              size="large"
              style={{
                width: "150px",
                height: "40px",
                borderRadius: "5px",
              }}
              type="primary"
            >
              <span>{formatMessage({ id: "submit" })}</span>
            </Button>
          </div>
        </div>
      </div>
    );
  };

  const renderFieldAttribute = useCallback(
    (rt, rtIndex, isOption = false, parentField = null) => {
      return (
        <div
          key={rtIndex}
          className={`content-creation-fieldattribute ${
            isOption ? "fieldattributeoptions" : ""
          }`}
        >
          <div className="fieldattribute-info">
            <div className="fieldattribute-info-left">
              <div className="attribute-icon">
                <div
                  className={`attribute-data-type-icon-container custom ${
                    isOption ? "" : "company-fields-icons"
                  }`}
                >
                  <Icon
                    rotate={
                      findsvgForTemplate(
                        rt.dataType || (rt.type === "text" ? 0 : 8),
                        rt.typeOfOptions
                      )?.rotate || 0
                    }
                    component={
                      isOption
                        ? BranchesOutlined
                        : findsvgForTemplate(
                            rt.dataType || (rt.type === "text" ? 0 : 8),
                            rt.typeOfOptions
                          )?.svg || FileUnknownOutlined
                    }
                  />
                </div>
              </div>
              <div className="fieldattribute-label">
                <div className="fieldattribute-static-label">
                  {isOption
                    ? rt
                    : rt.translation?.[_locale]?.label ||
                      rt.translation?.[_locale]?.title ||
                      rt.label ||
                      rt.title}
                </div>
              </div>
            </div>
            <div className="fieldattribute-right">
              <span>
                <Text
                  style={{ fontSize: "15px" }}
                  className="success-password"
                  copyable={{
                    text: isOption
                      ? parentField?.dataType === 6 &&
                        parentField?.typeOfOptions === "Multiple"
                        ? `<strong className="parameter_01" id=${rt._id}>{#if_eq_multi ${parentField?.field_label} '${rt}'}... {/if_eq_multi}</strong>&nbsp;`
                        : `<strong className="parameter_01" id=${rt._id}>{#if_eq ${parentField?.field_label} '${rt}'}... {/if_eq}</strong>&nbsp;`
                      : `<strong className="parameter_01" contenteditable="false" id=${
                          rt._id
                        }>{${rt.key || rt.field_label}}</strong>&nbsp;`,
                    format: "text/html",
                  }}
                  strong
                />
              </span>
            </div>
          </div>
        </div>
      );
    },
    [findsvgForTemplate, _locale]
  );

  const renderFieldsPanel = useCallback(
    (fields, panelKey, title, icon, isCustom = false) => {
      const filteredFields = isCustom
        ? fields
        : fields?.filter(
            (eve) =>
              ![
                "execution_date",
                "termination_date",
                "notice_for_renewal",
                "post_execution_status",
                "renewal",
              ].includes(eve?.field_label)
          );

      return (
        <Panel
          className={
            !(
              isCustom ? collapseRoleFieldsKey : collapsecontractFieldsKey
            ).includes(panelKey.toString())
              ? "content_role_fields panel-box"
              : "panel-box"
          }
          header={
            <>
              {icon}
              <span style={{ marginLeft: "5px" }}>
                {title}
                <span>
                  {!(
                    isCustom ? collapseRoleFieldsKey : collapsecontractFieldsKey
                  ).includes(panelKey.toString()) &&
                    ` (${filteredFields?.length || 0})`}
                </span>
              </span>
            </>
          }
          key={panelKey}
        >
          {filteredFields?.map((rt, rtIndex) => (
            <div key={rtIndex}>
              {renderFieldAttribute(rt, rtIndex)}
              {(Number(rt.dataType) === 3 ||
                (Number(rt.dataType) === 6 && (rt.multiSelect === false||["Single","Multiple"].includes(rt.typeOfOptions)))) && (
                <span>
                  {rt.options?.map((ert, ertIndex) => (
                    <div key={ertIndex}>
                      {renderFieldAttribute(ert, ertIndex, true, rt)}
                    </div>
                  ))}
                </span>
              )}
            </div>
          ))}
        </Panel>
      );
    },
    [collapseRoleFieldsKey, collapsecontractFieldsKey, renderFieldAttribute]
  );

  const renderSidebar = () => {
    if (!isSidebarvisible) return null;

    return (
      <Col className="content_left_sidebar" md={6} xs={24} sm={24}>
        <Tabs
          defaultActiveKey="1"
          className="content_sidebar_tab"
          tabBarExtraContent={
            <>
              {Key === "2" && (
                <Button
                  onClick={() =>
                    dispatch(setClauseModalVisible({ visible: true }))
                  }
                  type="link"
                  icon={<PlusOutlined />}
                />
              )}
              {Key === "1" && (
                <Dropdown menu={{ items: extraItems }}>
                  <Button type="link" icon={<PlusOutlined />} />
                </Dropdown>
              )}
            </>
          }
          activeKey={Key}
          onChange={(key) => {
            setKey(key);
            localStorage.setItem("contentactiveTab", key);
            setSearchText("");
          }}
          size="small"
          items={[
            { label: formatMessage({ id: "fields" }), key: "1" },
            localStorage.getItem("companyId") && {
              label: formatMessage({ id: "clause" }),
              key: "2",
            },
          ]}
        />

        {Key === "1" && (
          <div className="tab1_fields">
            <div className="attribute-category-header">
              <h5 className="attribute-category-label">
                {formatMessage({ id: "role_fields" })}
              </h5>
            </div>

            <Collapse
              onChange={setCollapseRoleFieldsKey}
              expandIconPosition="end"
              collapsible="header"
              defaultActiveKey={["1", "2"]}
            >
              {customAddedFields?.length > 0 &&
                renderFieldsPanel(
                  customAddedFields,
                  3,
                  formatMessage({ id: "custom_fields" }),
                  null,
                  true
                )}
              {renderFieldsPanel(
                backendvariablesforcontent?.companyVars,
                1,
                formatMessage({ id: "company_fields" }),
                <UserOutlined />,
                true
              )}
              {renderFieldsPanel(
                backendvariablesforcontent?.counterpartyVars,
                2,
                formatMessage({ id: "counterparty_fields" }),
                <UserOutlined />,
                true
              )}
            </Collapse>

            <div className="attribute-category-header">
              <h5 className="attribute-category-label">
                {formatMessage({ id: "contract_fields" })}
              </h5>
            </div>

            <Collapse
              expandIconPosition="end"
              collapsible="header"
              onChange={setCollapseContractFieldsKey}
              defaultActiveKey={["1"]}
            >
              {renderFieldsPanel(
                backendvariablesforcontent?.defaultTemplate,
                3,
                formatMessage({ id: "default_fields" }),
                <UserOutlined />
              )}

              {/* <Panel
                className={
                  !collapsecontractFieldsKey.includes("1")
                    ? "content_role_fields panel-box template-select"
                    : "panel-box template-select"
                }
                header="Contract"
                extra={
                  <div className="sidebar_tab_edit_template">
                    <Form.Item
                      style={{ margin: "0px" }}
                      labelAlign="left"
                      className="template_sidebar"
                      name="templete_ids"
                    >
                      <Select
                        className="select_template"
                        size="small"
                        style={{ width: "180px" }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        disabled={[
                          "taskEditContent",
                          "edittaskcontent",
                        ].includes(type)}
                        showArrow
                        dropdownMatchSelectWidth={false}
                        onChange={(value) => {
                          SetTemplate(value);
                          const Templatedataformention =
                            templateTableData
                              .filter((item) => value?.includes(item._id))
                              ?.map((eve) => ({
                                ...eve,
                                fields:
                                  [
                                    ...backendvariablesforcontent?.defaultTemplate,
                                    ...eve?.fields,
                                  ] || [],
                              })) || [];

                          const contentmentionsdata =
                            Templatedataformention.flatMap((ert) =>
                              ert.fields.map((rt, rtIndex) => ({
                                id: rtIndex,
                                fieldsname: rt.label,
                                fieldforcontent: `{${rt.field_label}}`,
                              }))
                            );

                          setUsers(contentmentionsdata);
                          setIsCkeditorVisible(false);

                          setTimeout(() => {
                            setIsCkeditorVisible(true);
                          }, 100);
                        }}
                        optionFilterProp="children"
                        showSearch
                        placeholder={formatMessage({ id: "selecttemp" })}
                      >
                        {templateTableData
                          .filter((item) => item?.historicalTemplate !== true)
                          .map((rt, index) => (
                            <Option key={index} value={rt._id}>
                              {rt?.templateTitle}
                              {rt?.prefix &&
                                rt?.recordNo &&
                                `(${rt.prefix + "-" + rt?.recordNo})`}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>

                    <div>
                      {Template && (
                        <CustomButton
                          icon={<EditOutlined />}
                          type="link"
                          disabled={!Template || Template.length === 0}
                          onClick={(e) => {
                            e.stopPropagation();
                            const dataSet = Templatedata.find(
                              (ert) => ert?._id === template_id || Template
                            );
                            dispatch(
                              createTemplateModal({
                                visible: true,
                                record: [
                                  "taskEditContent",
                                  "edittaskcontent",
                                ].includes(type)
                                  ? {
                                      fields: taskDetailsdata.dynamicParameters,
                                    }
                                  : dataSet,
                                taskDetailsdata: [
                                  "taskEditContent",
                                  "edittaskcontent",
                                ].includes(type)
                                  ? {
                                      ...taskDetailsdata,
                                      backendVerialble:
                                        backendvariablesforcontent,
                                    }
                                  : {
                                      ...dataSet,
                                      backendVerialble:
                                        backendvariablesforcontent,
                                    },
                                type: [
                                  "taskEditContent",
                                  "edittaskcontent",
                                ].includes(type)
                                  ? "editTaskForAddendum"
                                  : "editTaskTemplate",
                                content: contents,
                              })
                            );
                          }}
                        />
                      )}
                    </div>
                  </div>
                }
                key="1"
              >
                {type !== "edittaskcontent" &&
                  Templatedata.map((ert, ertIndex) => (
                    <div key={ertIndex}>
                      {ert.fields?.map((rt, rtIndex) => (
                        <div key={rtIndex}>
                          {renderFieldAttribute(rt, rtIndex)}
                          {(Number(rt.dataType) === 3 ||
                            (Number(rt.dataType) === 6 &&
                              rt.multiSelect === false)) && (
                            <span>
                              {rt.options?.map((option, optIndex) => (
                                <div key={optIndex}>
                                  {renderFieldAttribute(
                                    option,
                                    optIndex,
                                    true,
                                    rt
                                  )}
                                </div>
                              ))}
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}

                {["taskEditContent", "edittaskcontent"].includes(type) &&
                  taskDetailsdata?.dynamicParameters?.map(
                    (field, fieldIndex) => (
                      <div key={fieldIndex}>
                        <div>
                          {renderFieldAttribute(field, fieldIndex)}
                          {(Number(field.dataType) === 3 ||
                            (Number(field.dataType) === 6 &&
                              field.multiSelect === false)) && (
                            <span>
                              {field.options?.map((option, optIndex) => (
                                <div key={optIndex}>
                                  {renderFieldAttribute(
                                    option,
                                    optIndex,
                                    true,
                                    field
                                  )}
                                </div>
                              ))}
                            </span>
                          )}
                        </div>
                      </div>
                    )
                  )}
              </Panel> */}
            </Collapse>
          </div>
        )}

        {Key === "2" && (
          <div className="tab2_clauses">
            <Input
              style={{ marginBottom: "10px" }}
              size="large"
              placeholder="Search for clause..."
              prefix={<SearchOutlined />}
              onChange={(e) => setSearchText(e.target.value)}
              suffix={
                <Dropdown
                  menu={{
                    items: sortingItems,
                    selectable: true,
                    defaultSelectedKeys: ["5"],
                  }}
                >
                  <Button type="text" icon={<FilterOutlined />} />
                </Dropdown>
              }
            />

            <Spin style={{ height: "70vh" }} spinning={isClauseListLoading}>
              <div>
                {clausesfilteredData.map((rte, rteindex) => (
                  <div key={rteindex} className="clause_main_div">
                    <div className="clause_title_main_div">
                      <div className="clause_title">{rte?.clauseTitle}</div>
                      <Text
                        copyable={{
                          text: `<span style="color:#000000;font-size:12pt;font-weight:bold;font-family:Times New Roman;mso-fareast-font-family:'Times New Roman';mso-bidi-font-family:Times New Roman;lang:EN-US;mso-fareast-language:UK-UA;font-style:normal;font-variant:normal;text-decoration:none;direction: ltr;">${rte?.clauseTitle} : </span><span style="color:#000000;font-size:12pt;font-family:Times New Roman;mso-fareast-font-family:'Times New Roman';mso-bidi-font-family:Verdana;lang:EN-US;mso-fareast-language:UK-UA;font-weight:normal;font-style:normal;font-variant:normal;text-decoration:none;direction: ltr;">${rte?.clauseBody}</span>`,
                          format: "text/html",
                        }}
                      />
                    </div>
                    <div className="clause_body">{rte?.clauseBody}</div>
                  </div>
                ))}
              </div>
            </Spin>
          </div>
        )}
      </Col>
    );
  };

  const renderMainContent = () => {
    if (ContentDrawertype !== "fill") return null;

    return (
      <Spin spinning={contentPreviewLoading}>
        <Row className="content_creation_main">
          <Tooltip
            placement="topLeft"
            title={isSidebarvisible ? "Hide sidebar" : "Show sidebar"}
          >
            <Button
              size="large"
              style={{
                position: "absolute",
                top: "7px",
                zIndex: 10,
              }}
              onClick={() => setSidebarVisible(!isSidebarvisible)}
              icon={
                isSidebarvisible ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />
              }
            />
          </Tooltip>

          {renderSidebar()}

          <Col
            md={isSidebarvisible ? 18 : 24}
            sm={24}
            xs={24}
            style={{ marginBottom: "0px", backgroundColor: "#e7e7e7" }}
          >
            <div className="additional-toolbar">
              <UploadComponent
                beforeUpload={checkFileType}
                key="thumb_img_upload"
                accept=".doc, .docx, .txt"
                fileList={[]}
                getBase64File={(e) => {
                  dispatch(contentUploadDoc({ file: e.fileData }));
                }}
              >
                <Button icon={<DownloadOutlined />}>
                  <span className="import_btn">
                    {formatMessage({ id: "import" })}
                  </span>
                </Button>
              </UploadComponent>
              &nbsp;
              <Button
                onClick={() => {
                  dispatch(contentUploadhtmltoDoc({ htmlContent: contents }));
                }}
              >
                {formatMessage({ id: "export" })}
              </Button>
              &nbsp;
              <Form.Item
                style={{ margin: "0px" }}
                labelAlign="left"
                name="sample_content"
              >
                <Select
                  style={{ width: "220px" }}
                  getPopupContainer={(trigger) => trigger.parentNode}
                  optionFilterProp="children"
                  showSearch
                  allowClear
                  showArrow
                  disabled={editRecord?.contentStatus === 46 || false}
                  onChange={handlesampledatachange}
                  loading={isLoading}
                  placeholder={formatMessage({
                    id: "select_content_from_library",
                  })}
                >
                  {samplecontentTableData.map((rt, index) => (
                    <Option key={index} value={rt._id}>
                      {rt.contentName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              &nbsp;
              <Segmented
                value={editorMode}
                defaultValue={editorMode}
                onChange={(e) => {
                  console.log(e);
                  setEditorMode(e);
                  toggleMode(e);
                }}
                options={[
                  {
                    label: formatMessage({
                      id: "edit",
                    }),
                    value: "edit",
                    // icon: <BarsOutlined />,
                  },
                  {
                    label: formatMessage({
                      id: "tag",
                    }),
                    value: "tag",
                    // icon: <AppstoreOutlined />,
                  },
                ]}
              />
              <Button
                style={{ marginLeft: "8px" }}
                onClick={() => {
                  if (
                    creditDetails?.trial_buckets_total?.create_with_ai -
                      creditDetails?.trial_buckets_used?.create_with_ai ===
                    creditDetails?.trial_buckets_total?.create_with_ai
                  ) {
                    dispatch(
                      setCreditExhaustModalVisible({
                        visible: true,
                      })
                    );
                  } else {
                    dispatch(setContentDetails({ record: editRecord }));
                    history.push("/askai");
                  }
                }}
                icon={<Icon style={{ color: "#4e54c8" }} component={AiIcon} />}
              >
                <span className="import_btn">
                  {formatMessage({ id: "create_with" })}&nbsp;AI
                </span>
              </Button>
              &nbsp;
              <Popover
                content={
                  <>
                    <div>
                      <div>
                        1.{formatMessage({ id: "use" })} <b>$</b>{" "}
                        {formatMessage({ id: "for_contract_fields" })}
                      </div>
                      <div>
                        2.{formatMessage({ id: "use" })} <b>#</b>{" "}
                        {formatMessage({ id: "for_role_fields" })}
                      </div>
                    </div>
                  </>
                }
                title={formatMessage({ id: "help_box" })}
                trigger="hover"
              >
                <Button type="text" icon={<QuestionCircleOutlined />} />
              </Popover>
              {/* <button onClick={() => { setEditorMode("edit"); toggleMode("edit"); }}>Edit</button>
<button onClick={() => { setEditorMode("tag"); toggleMode("tag"); }}>Tag</button> */}
            </div>

            <Form.Item
              colon
              {...FORM_LAYOUTS.full}
              name="content"
              initialValue={editRecord.content ? editRecord?.content : " "}
              rules={[
                {
                  required: true,
                  message: formatMessage({ id: "content_rule" }),
                },
                { whitespace: true },
              ]}
            >
              <Spin spinning={!isckeditorvisible}>
                {isckeditorvisible && (
                  <CKEditor
                    onInstanceReady={(event) => {
                      const editor = event.editor;
                      editorRef.current = editor;

                      // Keep your CSS for pills
                      editor.document.appendStyleText(`
    .intuitive-tag {
      display:inline-block;
      background-color:#4CAF50;
      color:white;
      padding:4px 10px;
      border-radius:12px;
      font-size:14px;
      font-weight:600;
      line-height:1.4;
      cursor:pointer;
      user-select:none;
      white-space:nowrap;
    }
    .intuitive-tag:hover {
      background-color:#43a047;
    }
  `);

                      editor.on("paste", (evt) => {
                        let data = evt.data && evt.data.dataValue;
                        if (!data) return;

                        // Force all {var} to remain raw {var}, no pills
                        data = data.replace(
                          /\{([a-zA-Z0-9_]+)\}/g,
                          (match, tokenKey) => `{${tokenKey}}`
                        );
                        evt.data.dataValue = data;
                      });
                    }}
                    data={
                      contents
                        ? contents
                        : editRecordContent
                        ? editRecordContent
                        : editRecord.content
                        ? editRecord?.content
                        : ""
                    }
                    config={editorConfig}
                    onChange={(event) => {
                      const data = event.editor.getData();
                      if (
                        data.startsWith("<p>undefined</p>") ||
                        data === "<p>undefined</p>\n"
                      ) {
                        setContent("");
                        form.setFieldsValue({ content: "" });
                      } else {
                        setContent(data || "");
                        form.setFieldsValue({ content: data || "" });
                      }
                    }}
                  />
                )}
              </Spin>
            </Form.Item>
          </Col>
        </Row>

        <ContentPreviewModal {...props} />
      </Spin>
    );
  };

  return (
    <Drawer
      title={renderDrawerTitle()}
      closeIcon={
        <LeftOutlined style={{ fontWeight: "bold", fontSize: "22px" }} />
      }
      className="detailview-content-creation creation_new_content"
      width={window.innerWidth <= 720 ? "100%" : "100%"}
      onClose={() => modelClose(form)}
      open={isVisible}
      extra={renderDrawerExtra()}
      footer={false}
    >
      <Form
        name="register"
        layout="horizontal"
        labelWrap
        scrollToFirstError
        initialValues={{
          contentName: editRecord?.contentName,
        }}
        colon={false}
        form={form}
      >
        {renderCreateContentForm()}
        {renderMainContent()}
      </Form>
    </Drawer>
  );
};

export default CreateContent;
